/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  toValue.ts
 */

import { ExpirableLRUOptions } from '../types/ExpirableLRUOptions'
import { StoredData } from '../types/StoredData'

import { isValidStoredData } from './isValidStoredData'

export const toValue = <TValue = any>(
  data: StoredData<TValue>,
  options: ExpirableLRUOptions<any, TValue>
) => {
  if (isValidStoredData(data, options)) {
    return data[0]
  }
  return undefined
}
